import React from 'react'
import style from './articles.style'

const YandexDirectUTM = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Рекомендации по разметке кампаний Яндекс директ для работы в ROMI center</h2>

      <p>
        Сервис ROMI center работает поверх сервиса веб аналитики Google Analytics.<br />
        Google Analytics используется хранения данных о переходах, затратах, конверсиях и продажах.<br />
        Детализация аналитики производится в разрезе utm меток.<br />
        Для корректной работы ROMI center требуется правильная разметка utm-метками объявлений в рекламных кампаниях.
      </p>

      <p>
        ROMI center рекомендует формировать utm метки следующим образом:<br />
        utm_medium=cpc<br />
        utm_source=yandex<br />
        utm_campaign=&lsaquo;название кампании&rsaquo;  или {'{'}campaign_name{'}'} (здесь &lsaquo;название кампании&rsaquo; статичный текст латиницей)<br />
        utm_term={'{'}keyword{'}'} (здесь {'{'}keyword{'}'} - динамический параметр, который подставляется автоматически Яндекс директом)<br />
        utm_content=(произвольная разметка, может содержать статический текст и динамические параметры Яндекс директа)
      </p>

      <p>
        Пример разметки рекламных кампаний Яндекс директа:<br />
        http://test.com/?utm_source=yandex&utm_medium=cpc&utm_campaign={'{'}campaign_name{'}'}&utm_term={'{'}keyword{'}'}
      </p>

      <p>
        При разметке рекламных кампаний Яндекс Директ вы можете также использовать динамические параметры Яндекс Директ.
      </p>

      <h3>Поддерживаемые параметры</h3>

      <p>
        При загрузке данных о расходах по кампаниям Яндекс Директ ROMI center обрабатывает следующие значения динамических параметров в utm-метках:
      </p>

      <table cellpadding="10" border="1">
        <thead style={{textAlign: 'left'}}>
          <tr>
            <th>Название параметра</th>
            <th>Описание</th>
          </tr>
        </thead>
        <tbody style={{textAlign: 'left'}}>
          <tr>
            <td>{'{'}ad_id{'}'}</td>
            <td>Номер (ID) объявления (Число)</td>
          </tr>
          <tr>
            <td>{'{'}banner_id{'}'}</td>
            <td>
              Номер (ID) объявления на баннере (Число)
            </td>
          </tr>
          <tr>
            <td>{'{'}addphrases{'}'}</td>
            <td>
              Произошел ли показ по дополнительными релевантными фразами (yes — показ по дополнительной релевантной фразе;<br />
              no — показ по одной из исходных фраз)
            </td>
          </tr>
          <tr>
            <td>{'{'}campaign_name{'}'}</td>
            <td>Название кампании (Текст до 60 символов)</td>
          </tr>
          <tr>
            <td>{'{'}campaign_name_lat{'}'}</td>
            <td>Транслитерированное название кампании (Текст латиницей до 60 символов. Важно: этот параметр обрабатывается только если название кампании в рекламном кабинете содержит текст латиницей, цифры и/или спецсимволы. В других случаях, например если в названии будет текст кириллицей, значение параметра не будет распознано)</td>
          </tr>
          <tr>
            <td>{'{'}campaign_type{'}'}</td>
            <td>Тип кампании<br />
              (type1 — текстово-графические объявления;<br />
              type2 — реклама мобильных приложений;<br />
              type3 — динамические объявления;<br />
              type4 — смарт баннеры.)
            </td>
          </tr>
          <tr>
            <td>{'{'}campaign_id{'}'}</td>
            <td>Идентификатор рекламной кампании (Число)</td>
          </tr>
          <tr>
            <td>{'{'}device_type{'}'}</td>
            <td>Тип устройства, на котором произведен показ (desktop / mobile / tablet)</td>
          </tr>
          <tr>
            <td>{'{'}gbid{'}'}</td>
            <td>Идентификатор группы (Число)</td>
          </tr>
          <tr>
            <td>{'{'}keyword{'}'}</td>
            <td>Ключевая фраза, по которой было показано объявление (Только для типов  кампаний текстово-графические объявления или реклама мобильных приложений) (Число) *</td>
          </tr>
          <tr>
            <td>{'{'}phrase_id{'}'}</td>
            <td>Идентификатор ключевой фразы для текстово-графических объявлений или рекламы мобильных приложений. (Число) **</td>
          </tr>
          <tr>
            <td>{'{'}retargeting_id{'}'}</td>
            <td>Идентификатор условия нацеливания на аудиторию, связывающего группу объявлений с условиями ретаргетинга и подбора аудитории или интересами к мобильным приложениям. (Число) ***</td>
          </tr>
          <tr>
            <td>{'{'}coef_goal_context_id{'}'}</td>
            <td>Идентификатор корректировки ставок для условия ретаргетинга и подбора аудитории. (Число)</td>
          </tr>
          <tr>
            <td>{'{'}match_type{'}'}</td>
            <td>
              Тип соответствия условия показа и поискового запроса. (rm — автотаргетинг;<br />
              syn — синоним;<br />
              rkw — дополнительная релевантная фраза)
            </td>
          </tr>
          <tr>
            <td>{'{'}adtarget_name{'}'}</td>
            <td>Условие нацеливания динамического объявления</td>
          </tr>
          <tr>
            <td>{'{'}adtarget_id{'}'}</td>
            <td>Идентификатор условия нацеливания динамического объявления (Число)</td>
          </tr>
          <tr>
            <td>{'{'}position_type{'}'}</td>
            <td>
              Тип блока, если показ произошел на странице с результатами поиска Яндекса<br />
              (premium — премиум-показы;<br />
              other — блок справа или блок внизу;<br />
              none — объявление было показано в сетях, РСЯ или внешние сети.)
            </td>
          </tr>
          <tr>
            <td>{'{'}source{'}'}</td>
            <td>
              Место показа (none — при показе на поиске Яндекса;<br />
              При показе на поисковых площадках РСЯ может быть передан как домен, так и значение none)
            </td>
          </tr>
          <tr>
            <td>{'{'}source_type{'}'}</td>
            <td>
              Тип площадки, на которой произведен показ объявления (search — поиск;<br />
              context — сети)
            </td>
          </tr>
          <tr>
            <td>{'{'}region_name{'}'}</td>
            <td>Регион, в котором было показано объявление</td>
          </tr>
          <tr>
            <td>{'{'}region_id{'}'}</td>
            <td>Идентификатор региона, в котором было показано объявление </td>
          </tr>
        </tbody>
      </table>

      <h3>Неподдерживаемые параметры</h3>

      <p>Некоторые параметры Яндекс Директ не передает в API, поэтому они не поддерживаются.</p>

      <table cellPadding="10" border="1">
        <thead style={{textAlign: 'left'}}>
        <tr>
          <th>Название параметра</th>
          <th>Описание</th>
          <th>Значения</th>
        </tr>
        </thead>
        <tbody style={{textAlign: 'left'}}>
          <tr>
            <td>{'{'}addphrasestext{'}'}</td>
            <td>Текст автоматически добавленной фразы</td>
            <td>
              Текст фразы;<br /><br />
              none, если показ не был инициирован автоматически добавленной фразой
            </td>
          </tr>
          <tr>
            <td>{'{'}creative_id{'}'}</td>
            <td>Идентификатор креатива из конструктора</td>
            <td>Число</td>
          </tr>
          <tr>
            <td>{'{'}interest_id{'}'}</td>
            <td>Идентификатор интереса к <a href="https://yandex.ru/support/direct/impression-criteria/interest-targeting.html" target="_blank">мобильным приложениям</a></td>
            <td>Число</td>
          </tr>
          <tr>
            <td>{'{'}matched_keyword{'}'}</td>
            <td>Подобранная фраза (используйте вместе с {'{'}match_type{'}'})</td>
            <td>Текст подобранной фразы, синонима или дополнительной релевантной фразы</td>
          </tr>
          <tr>
            <td>{'{'}position{'}'}</td>
            <td>Точная позиция объявления в блоке</td>
            <td>Номер позиции в блоке</td>
          </tr>
          <tr>
            <td>{'{'}param1{'}'}</td>
            <td>Специальный параметр 1</td>
            <td></td>
          </tr>
          <tr>
            <td>{'{'}param2{'}'}</td>
            <td>Специальный параметр 2</td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <p>
        Если вы используете в UTM-метках параметры, которые не поддерживаются в API, то увидите названия самих параметров вместо их значений. Например, <strong>{'{'}position{'}'}</strong> вместо <strong>1</strong>. Это не позволит проверить затраты в разрезе UTM-меток в отчетах.
      </p>

      <p>Чтобы получать отчеты по затратам в разрезе UTM-меток, перенесите параметры, которые не поддерживаются в API, из UTM-меток в дополнительные GET-параметры и собирайте их в пользовательские параметры Google Analytics:</p>

      <ul>
        <li>данные по расходам будут доступны только в разрезе передаваемых UTM-меток,</li>
        <li>сессионные данные будут доступны в разрезе неподдерживаемых динамических параметров (в пользовательских параметрах) и UTM-меток.</li>
      </ul>

      <p>
        * Параметры {'{'}keyword{'}'}, {'{'}phrase_id{'}'} и {'{'}retargeting_id{'}'} — поддерживаются частично. При наличии всех трёх в одной ссылке, динамические значения в некоторых из них не будут передаваться. Если наличие одного из этих параметров некритично для вашей кампании — уберите его из ссылок, чтобы получать корректные динамические значения.
      </p>

    </article>
  )
}

export default style(YandexDirectUTM)
